import styled from "styled-components";
import { Headline, Paragraph } from "../../../components/styled/Text";

const InfoBlockContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
`;

const InfoBlockHeadline = styled(Headline)`
  font-size: 34px;
`;

const InfoBlock = () => {
  return (
    <InfoBlockContainer>
      <InfoBlockHeadline textAlign="center">
        Relaunch complete 🎉
      </InfoBlockHeadline>
      <Paragraph textAlign="center">
        You have successfully relaunched your token. Now it's up to you, to
        notify your projects community about your newly relaunched token.
      </Paragraph>
    </InfoBlockContainer>
  );
};

export default InfoBlock;
